module.exports = __webpack_public_path__ + "static/img/2.81f8af5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/2.png
// module id = afb/
// module chunks = 0